import React from "react";
import styles from "./FoundationalStage.module.css";
import { cleanLines, stripBoldTitle } from "../OnboardingStage/utils";

const parseBlogSeo = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const intro = [];
  const urls = [];
  const actionLines = [];
  let phase = "intro";

  lines.forEach((line) => {
    if (/^https?:\/\//.test(line) || /^[•\-*]\s*https?:\/\//.test(line)) {
      phase = "urls";
      urls.push(line.replace(/^[•\-*]\s*/, ""));
    } else if (/we will execute/i.test(line)) {
      phase = "actions";
      actionLines.push(line.trim());
    } else if (phase === "actions") {
      actionLines.push(line.trim());
    } else if (phase === "urls" && /^[•\-*]\s/.test(line)) {
      urls.push(line.replace(/^[•\-*]\s*/, ""));
    } else {
      intro.push(line);
    }
  });

  return {
    intro: intro.join(" ").trim(),
    urls,
    actionText: actionLines.join(" ").trim(),
  };
};

const BlogSeoUplift = ({ markdown = "" }) => {
  const { intro, urls, actionText } = parseBlogSeo(markdown);
  if (!intro && !urls.length && !actionText) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Blog SEO Uplift</h3>
      {intro ? (
        <div className={styles.card}>
          <p className={styles.paragraph}>{intro}</p>
        </div>
      ) : null}
      {urls.length ? (
        <div className={styles.summaryCard}>
          <h4 className={styles.summaryTitle}>Blog URLs</h4>
          <ul className={styles.urlList}>
            {urls.map((url, idx) => (
              <li key={idx} className={styles.urlItem}>
                {url}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {actionText ? (
        <div className={styles.actionCard}>
          <p className={styles.actionTitle}>Execution Plan</p>
          <p className={styles.actionText}>{actionText}</p>
        </div>
      ) : null}
    </div>
  );
};

export default BlogSeoUplift;
